import { Modal } from 'antd'

interface LoginModalProps {
  open: boolean
  onCancel?: () => void
}

/**
 * 登录弹窗
 * @returns
 */
const LoginModal = ({ open, onCancel }: LoginModalProps) => {
  const { pathname, search } = useLocation()

  useEffect(() => {
    if (open) {
      const obj = new window.WxLogin({
        fast_login: 1,
        self_redirect: false,
        id: 'login_container',
        appid: import.meta.env.VITE_WX_APP_ID,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(`https://tianfuqiyue.com/callback?redirect=${pathname + search}`),
        state: `${__PROD__ ? fakeId() : __TEST__ ? 'test' : 'dev'}`,
        style: '1',
        href: '',
        onReady: (isReady: boolean) => {
          jLog('onReady', isReady, obj)
        },
      })
    }
  }, [open])

  return (
    <Modal centered footer={false} open={open} title={false} width={440} onCancel={onCancel}>
      <div className="m-auto h-400px w-300px" id="login_container"></div>
    </Modal>
  )
}
export default LoginModal
